







































import Vue from "vue";
import { mapGetters, mapState } from "vuex";
import iwPictures from "@/encoding/pages/Pictures.vue";
import iwPictureModal from "@/encoding/components/PictureModal.vue";
import { deleteOrderPublishPictures, deleteRemotePictures } from "@/shared/scripts/UploadPicture";
import { Picture } from "@/shared/interfaces/Picture.interface";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";
import { getClassifiedId } from "@/shared/scripts/ClassifiedsApi";

export default Vue.extend({

    components: {
        iwPictures: iwPictures,
        iwPictureModal: iwPictureModal
    },

    data: function() {
        return {
            picturesNotModified: this.$store.getters["PicturesModule/getPictures"] as Array<Picture>,
            masqueradeTitleIsFixed: false as boolean,
        };
    },

    computed: {
        ...mapState("UserModule", ["user"]),
        ...mapGetters({
            isLogged: "UserModule/isLogged",
            isMasquerading: "UserModule/isMasquerading",
        }),

        hasAtLeastOnePicture: function(): boolean {
            const pictures = this.$store.getters["PicturesModule/getPictures"] as Array<Picture>;
            return Boolean(pictures && pictures.length > 0);
        }
    },

    mounted: function() {
        const classifiedId = this.$route.params.id;
        if(classifiedId) {
            getClassifiedId(classifiedId);
        }
        if(this.isMasquerading) {
            let root = this.$root.$children[0] as Vue;
            if (root) {
                for(let index = 0; index < root.$children.length; index++) {
                    let topNavigation = root.$children[index] as Vue;
                    if(topNavigation) {
                        if(topNavigation.$el.className === "container--main-header") {
                            topNavigation.topNavigationIsFixed = false;
                        }
                    }
                }
            }
        }
    },

    methods: {
        goBackToMyClassifieds: function() {
            this.$store.commit("PicturesModule/setPictures", this.picturesNotModified);
            deleteRemotePictures(true).then(() => {
                let urlTranslated = this.$t("my-immoweb") as string;
                const to = this.$router.resolve({path: urlTranslated});
                this.$router.push(to.location);
            });
        },
        apply: function() {
            if (!this.hasAtLeastOnePicture) {
                return;
            }

            deleteOrderPublishPictures(true).then(() => {
                let urlTranslated = this.$t("my-immoweb") as string;
                const to = this.$router.resolve({path: urlTranslated});
                this.$router.push(to.location);
            }).catch(() => {
                this.dialog.alert(i18n.t("server_not_responding_error").toString());
            });
        },
        handleMasqueradeTitleScroll: function() {
            let documentElement = (
                document.scrollingElement ||
                document.documentElement ||
                document.body.parentNode ||
                document.body
            ) as HTMLElement;

            let documentScrollTop = 0;
            if(documentElement) {
                documentScrollTop = documentElement.scrollTop;
            }

            // Top Navigation
            let topNavigation = document.getElementById("masquerade-title");
            if (topNavigation) {
                if (documentScrollTop > 1) {
                    this.masqueradeTitleIsFixed = true;
                } else {
                    this.masqueradeTitleIsFixed = false;
                }
            }
        }
    }
});
